import React, { useEffect, useState } from 'react';
import {
  Button, Input, Select, Space, Typography, notification,
} from 'antd';
import api from '../../../utils/api';
import queueStore, { updateQueueStore } from '../../Store/queueStore';
import { getScreens, replaceButton, saveZone } from '../../../utils/zoneMutations';

// Очередь создаётся немедленно и по-настоящему — предупреждаем об этом прямо в форме.
function NewQueueMiniForm({
  screenId, button, onDone, onCancel,
}) {
  const [workWeeks, setWorkWeeks] = useState([]);
  const [values, setValues] = useState({
    name: '',
    fullname: '',
    prefix: '',
    position: '',
    workWeek: { workWeekId: '', workWeekName: '' },
  });

  useEffect(() => {
    (async () => {
      const res = await api.getWorkWeeks();
      const list = res?.data || [];
      setWorkWeeks(list);
      if (list.length) {
        setValues((prev) => ({
          ...prev,
          workWeek: { workWeekId: list[0].id, workWeekName: list[0].name },
        }));
      }
    })();
  }, []);

  const create = async () => {
    const res = await api.addQueue({ ...values });

    if (!res.status) {
      notification.error({ message: res.errMessage });
      return;
    }

    const queueRes = await api.getQueue();
    updateQueueStore({ queue: queueRes?.data || queueStore.getRawState().queue });

    const nextScreens = replaceButton(getScreens(), screenId, {
      ...button,
      path: 'print',
      params: { name: 'queue', value: res.createdQueueId },
    });

    await saveZone(nextScreens, 'Очередь создана и привязана');
    onDone(res.createdQueueId);
  };

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Typography.Text strong>Новая очередь</Typography.Text>
      <Typography.Text type="warning" style={{ fontSize: 12 }}>
        Очередь создаётся сразу и останется в разделе «Услуги», даже если передумать
      </Typography.Text>
      <Input
        placeholder="Название"
        value={values.name}
        onChange={(e) => setValues((prev) => ({ ...prev, name: e.target.value }))}
      />
      <Input
        placeholder="Полное название"
        value={values.fullname}
        onChange={(e) => setValues((prev) => ({ ...prev, fullname: e.target.value }))}
      />
      <Input
        placeholder="Префикс"
        value={values.prefix}
        onChange={(e) => setValues((prev) => ({ ...prev, prefix: e.target.value }))}
      />
      <Select
        style={{ width: '100%' }}
        value={values.workWeek.workWeekId}
        onChange={(id) => setValues((prev) => ({
          ...prev,
          workWeek: { workWeekId: id, workWeekName: workWeeks.find((w) => w.id === id)?.name },
        }))}
        options={workWeeks.map((week) => ({ value: week.id, label: week.name }))}
      />
      <Space>
        <Button type="primary" disabled={!values.name} onClick={create}>
          Создать и привязать
        </Button>
        <Button onClick={onCancel}>Отмена</Button>
      </Space>
    </Space>
  );
}

export default NewQueueMiniForm;
